import styled from 'styled-components';

export const WidgetContainer = styled.article`
  display: none;
  align-items: center;
  
  color: ${({ theme }) => theme.white};
  
  @media(min-width: 700px) {
    display: flex;
  }
  
  @media(min-width: 1024px) {
    margin-left: auto;
    margin-right: 75px;
  }
`;

export const WidgetIcon = styled.div`
  margin-right: 10px;
  
  svg {
    width: 30px;
    height: 30px;
    
    fill: ${({ theme }) => theme.white};
  }
`;

export const WidgetDescription = styled.p`
  margin: 0;
  padding: 0;
  
  font-size: 16px;
  line-height: 1;
`;

export const WidgetDot = styled.span`
  margin: 0 5px;
  margin-bottom: -3px;
  font-size: 30px;
`;
